import { loadDownloadLinks } from '../sources/io';

export const useDownloadTemplate = () => async () => {
  const downloadLink = await loadDownloadLinks();
  window.open(`${downloadLink}`, '_blank');
};
